module.exports = __webpack_public_path__ + "img/banner-22.6d7c7274.jpg";